import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HomeTxtsKey } from '../../pages/home/h-interfaces/txt-h-keys/home-txt-key.interface';
import { CalendarAppointmentDialogComponent } from './components/calendar-appointment-dialog/calendar-appointment-dialog.component';

@Component({
  selector: 'app-contact-options',
  templateUrl: './contact-options.component.html',
  styleUrls: ['./contact-options.component.scss']
})
export class ContactOptionsComponent {
  /* ========================================================== ATRIBUTES ========================================================== */
  @Input() texts?: HomeTxtsKey;
  @Input() imgAgenda?: string;


  /* ========================================================== CONSTRUCTOR ========================================================== */
  constructor(private dialog: MatDialog) {}



  /* ========================================================== METHODS ========================================================== */
  /* ---------------------------------------------------- Meth. Lifecycle Hooks ---------------------------------------------------- */



  /* ---------------------------------------------------- Meth. HTML ---------------------------------------------------- */



  /* ---------------------------------------------------- Meth. Listening ---------------------------------------------------- */



  /* ---------------------------------------------------- Meth. Common ---------------------------------------------------- */



  /* ---------------------------------------------------- Meth. Modal load file ---------------------------------------------------- */
  openCalendarDialog(): void {
    this.dialog.open(CalendarAppointmentDialogComponent, {
      width: '70vw',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: false,
    });
  }


  /* ---------------------------------------------------- Meth. Services ---------------------------------------------------- */

}
